import React from 'react';
import './PricingSection.css';
import PixelCard from '../PixelCard';

const PricingSection = ({ id, ...props }) => {
  const getCurrentDate = () => {
    const today = new Date();
    const day = today.getDate();
    const months = [
      'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
      'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
    ];
    const month = months[today.getMonth()];
    const year = today.getFullYear();
    
    return `${day} ${month} ${year}`;
  };
  
  return (
    <section className="pricing-section" id={id} {...props}>
      <div className="pricing-container">
        <div className="pricing-header">
          <h2 className="pricing-title">Выберите тариф для себя</h2>
          <div className="pricing-subtitle">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M10 1L13 7L19 7L14 11L16 17L10 14L4 17L6 11L1 7L7 7L10 1Z" fill="#00ff88"/>
            </svg>
            Все тарифы защищены 14-дневной гарантией возврата денег
          </div>
        </div>

        <div className="pricing-grid">
          {/* 1 месяц */}
          <div className="pricing-card">
            <div className="card-header">
              <div className="plan-badge standard">Подходит для старта</div>
              <h3 className="plan-name">1 месяц</h3>
            </div>
            <div className="card-body">
              <div className="price-section">
                <span className="price">340₽</span>
                <span className="period">/месяц</span>
              </div>
              <div className="billing-info">340₽ за месяц</div>
              <div className="features-list">
                <div className="feature">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M13.5 4.5L6 12L2.5 8.5" stroke="#00ff88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Неограниченный трафик
                </div>
                <div className="feature">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M13.5 4.5L6 12L2.5 8.5" stroke="#00ff88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Все локации
                </div>
                <div className="feature">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M13.5 4.5L6 12L2.5 8.5" stroke="#00ff88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  3 пользователя одновременно
                </div>
              </div>
            </div>
            <a href='https://t.me/redbutton_vpn_bot' target='_blank'><button className="select-button">Выбрать план</button></a>
          </div>

          {/* 1 год - ПОПУЛЯРНЫЙ */}
          <div className="pricing-card popular">
            <div className="popular-badge">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M8 1L10.5 5.5L15 6L11.5 9.5L12.5 14L8 12L3.5 14L4.5 9.5L1 6L5.5 5.5L8 1Z" fill="white"/>
            </svg>
            ЭКОНОМИЯ 49%
          </div>
            <div className="card-header">
              <div className="plan-badge popular-badge-small">Самый популярный</div>
              <h3 className="plan-name">1 год + 2 месяца БЕСПЛАТНО</h3>
            </div>
            <div className="card-body">
              <div className="price-section">
                <span className="price">200₽</span>
                <span className="period">/месяц</span>
              </div>
              <div className="original-price">Обычная цена: <span>390₽</span></div>
              <div className="billing-info">2800₽ за 14 месяцев</div>
              <div className="features-list">
                <div className="feature">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M13.5 4.5L6 12L2.5 8.5" stroke="#00ff88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Все возможности
                </div>
                <div className="feature">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M13.5 4.5L6 12L2.5 8.5" stroke="#00ff88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Поддержка 24/7
                </div>
                <div className="feature">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M13.5 4.5L6 12L2.5 8.5" stroke="#00ff88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  VIP приоритет
                </div>
              </div>
            </div>
            <a target='_blank' href="https://t.me/redbutton_vpn_bot"><button className="select-button popular-button">Выбрать план</button></a>
            
          </div>

          {/* 6 месяцев */}
          <div className="pricing-card">
            <div className="card-header">
              <div className="plan-badge savings">Скидка 36%</div>
              <h3 className="plan-name">6 месяцев</h3>
            </div>
            <div className="card-body">
              <div className="price-section">
                <span className="price">250₽</span>
                <span className="period">/месяц</span>
              </div>
              <div className="billing-info">1500₽ за 6 месяцев</div>
              <div className="features-list">
                <div className="feature">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M13.5 4.5L6 12L2.5 8.5" stroke="#00ff88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Все возможности
                </div>
                <div className="feature">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M13.5 4.5L6 12L2.5 8.5" stroke="#00ff88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Поддержка 24/7
                </div>
                <div className="feature">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M13.5 4.5L6 12L2.5 8.5" stroke="#00ff88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Приоритет
                </div>
              </div>
            </div>
            <a href='https://t.me/redbutton_vpn_bot' target='_blank'><button className="select-button">Выбрать план</button></a>
          </div>
        </div>

        <div className="pricing-footer">
          <div className="payment-methods">
          <div className="payment-title">Принимаем к оплате:</div>
          <div className="payment-placeholder">
            <img src="assets/1.svg" alt="Способы оплаты" className="payment-image" />
            <img src="assets/2.svg" alt="Способы оплаты" className="payment-image" />
            <img src="assets/3.svg" alt="Способы оплаты" className="payment-image" />
            <img src="assets/4.svg" alt="Способы оплаты" className="payment-image" />
            <img src="assets/5.svg" alt="Способы оплаты" className="payment-image" />
            <img src="assets/6.svg" alt="Способы оплаты" className="payment-image" />
            <img src="assets/8.svg" alt="Способы оплаты" className="payment-image" />
          </div>
        </div>
          
          <div className="trust-indicators">
            <div className="trust-item">
            <div className="live-indicator">
              <div className="status-dot"></div>
            </div>
            <span>
  Работает в России <img src="https://flagcdn.com/w20/ru.png" alt="RU" style={{width: '16px', height: '12px', marginLeft: '6px'}} />
  
</span>
          </div>
            <div className="legal-text">
              Проверено {getCurrentDate()} • Все суммы в рублях без НДС
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;